<template>
  <div id="conversion">
    <div class="header flex-between">
      <div class="header-text">
        <h1>积分商城兑换查询</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-notebook-2"
          @click="SelectdisplayitemDialog = true"
          >选择显示项</el-button
        >
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="Integralbtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.synchronization"
          icon="el-icon-edit-outline"
          @click="Synchronization"
          >同步</el-button
        >
        <el-button
          v-if="jurisdiction.abandon"
          icon="el-icon-edit-outline"
          @click="wastebtn"
          >废弃</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="goToPointsShopping"
          >查看</el-button
        >
        <el-button v-if="jurisdiction.export" @click="exportShow = true"
          >导出</el-button
        >
        <el-button
          v-if="jurisdiction.export"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出积分商城兑换记录"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>导出积分商城兑换记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载文件"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 选择显示列弹窗 -->
    <div>
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="显示项"
        :visible.sync="SelectdisplayitemDialog"
      >
        <el-row :gutter="20">
          <el-col
            v-for="(item, index) in Selectdisplayitem"
            :key="index"
            :span="6"
          >
            <el-checkbox-group
              @change="handleCheckedCitiesChange"
              v-model="Selectdisplayiteme"
            >
              <el-checkbox :label="item.ID">{{ item.titleName }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectfinish">选择完成</el-button>
          <el-button @click="Restoredefault">恢复默认选项</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 同步提示框 -->
    <div class="Enabledisable">
      <el-dialog
        width="20%"
        title="同步提示框"
        :visible.sync="EnabledisableFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">同步</span>此商品?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Enabledisableqd">确 定</el-button>
          <el-button @click="EnabledisableFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择门店弹窗 -->
    <div class="outlet">
      <el-dialog
        :close-on-click-modal="false"
        width="30%"
        :visible.sync="outletVisible"
        title="选择门店"
      >
        <el-form size="mini" label-width="90px">
       
          <el-row
            :gutter="50"
            v-for="(item, index) in StoreSelectionList"
            :key="index"
          >
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="shopID"
                highlight-current
                default-expand-all
                :default-checked-keys="xuanzhong"
                :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <el-card shadow="never">
      <div>
        <el-form label-width="110px" :model="Sercherbox" size="mini">
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="redItem" :inline="true" label="兑换记录编号">
                <el-input v-model="Sercherbox.redemptionNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="POS领取单号">
                <el-input v-model="Sercherbox.getNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品类型">
                <el-select style="width: 100%" v-model="Sercherbox.commKind">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="礼券" value="0"></el-option>
                  <el-option label="礼品" value="1"></el-option>
                  <el-option label="劵包" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item label="会员卡号\姓名">
                <el-input v-model="Sercherbox.search"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="领取方式">
                <el-select
                  style="width: 100%"
                  v-model="Sercherbox.collectMethod"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="到店自取" value="1"></el-option>
                  <el-option label="快递邮寄" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input v-model="Sercherbox.commodityName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item :inline="true" label="状态">
                <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
                <el-select style="width: 100%" v-model="Sercherbox.state">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未领取" value="0"></el-option>
                  <el-option label="已领" value="1"></el-option>
                  <el-option label="废弃" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="兑换日期从">
                <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
                <el-date-picker
                  v-model="Sercherbox.startRedemptionTime"
                  type="date"
                  placeholder="开始日期"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="至">
                <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
                <el-date-picker
                  v-model="Sercherbox.endRedemptionTime"
                  type="date"
                  placeholder="结束日期"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item label="区域">
                <el-select
                  v-model="Sercherbox.regionIds"
                  multiple
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-col :span="20">
                <el-form-item
                  label-width="85px"
                  style="margin: 0px; padding: 0px"
                  label="门店"
                >
                  <textarea
                    style="width: 100%; margin: 0px; padding: 0px"
                    rows="4"
                    readonly
                    v-model="Sercherbox.listOfSomeStoreslStr"
                  ></textarea>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="margin-left: -40px">
                <el-button
                  @click="outletVisible = true"
                  style="height: 35px; line-height: 10px"
                  >选择门店</el-button
                >
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" style="margin-top: 10px">
      <el-table
        :key="key"
        class="table-style"
        size="small"
        border
        :height="isMore ? 'calc(100vh - 31rem)' : 'calc(100vh - 30rem)'"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
      >
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio
              v-model="radio"
              :label="scope.$index"
              @change.native="handleRadioChange(scope.row)"
              >&nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formThead"
          :key="index"
          :label="item.titleName"
          :prop="item.fieldName"
        ></el-table-column>
        <!-- <el-table-column prop="redemptionNo" label="兑换记录编号">
        </el-table-column>
        <el-table-column prop="commodityName" label="商品名称">
        </el-table-column>
        <el-table-column prop="commKind" label="类型">
          <template slot-scope="scope">
            {{
              scope.row.commKind == 0
                ? "礼劵"
                : scope.row.commKind == 1
                ? "礼品"
                : scope.row.commKind == 2
                ? "劵包"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.state == 0
                ? "未领取"
                : scope.row.state == 1
                ? "已领"
                : scope.row.state == 2
                ? "废弃"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="custName" label="会员"> </el-table-column>
        <el-table-column prop="creditPoint" label="商品积分"> </el-table-column>
        <el-table-column prop="qty" label="兑换数量"> </el-table-column>
        <el-table-column prop="exchangeSumPoint" label="兑换总积分">
        </el-table-column>
        <el-table-column prop="redemptionTime" label="兑换日期">
          <template slot-scope="scope">
            {{ scope.row.redemptionTime | dateFormats }}
          </template>
        </el-table-column>
        <el-table-column prop="getTime" label="领取日期">
          <template slot-scope="scope">
            <div v-if="scope.row.getTime !== null">
              {{ scope.row.getTime | dateFormat }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormats }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column> -->
      </el-table>
      <el-alert
        v-if="isMore"
        title="没有更多数据了!"
        type="warning"
        center
        show-icon
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import {
  ReportgetdisplayfiledApi,
  reportFormList,
  RegionApi,
} from "@/api/reportForm";
import { TApiLogsyncProcess } from "@/api/couponsDepot.js";
import {
  lntegralqueryApi,
  wastebtnqueryApi,
  redemptionReportExportApi,
} from "@/api/Integralquery";
export default {
  name: "centre",
  data() {
    return {
      formThead: [],
      key: "",
      ID1: "",
      Selectdisplayitem: [],
      Selectdisplayiteme: [],
      SelectdisplayitemDialog: false,
      //
      exportShow: false,
      downloadData: [],
      downloadShow: false,

      EnabledisableFormVisible: false,
      jurisdiction: {
        search: false,
        abandon: false,
        look: false,
        synchronization: false,
        export: false,
      },
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      radio: "",
      loading: false,
      //积分商城兑换查询列表
      tableData: [],
      //积分商城btn查询
      count: 1,
      pages: 0,
      pageNo: 1,
      //单选存入
      changeRadioValue: [],
      Sercherbox: {
        displayFiled: [],
        pageNo: 1, //页
        pageSize: 20, //条
        redemptionNo: "", //兑换编号
        search: "", //搜索内容
        collectMethod: "", //领取方式
        commKind: "", //商品类型
        state: "", //状态
        startRedemptionTime: "", //开始时间
        endRedemptionTime: "", //结束时间
        getNo: "", //pos领取单号
        commodityName: "", //商品名称

        regionIds: [], // 区域
        listOfSomeStoreslStr: "", // 门店
        listOfSomeStoresl: [],
        shopIds: [],
      },
      //选中数据查看接受
      changeRadioLabel: [],

      regionList: [],
      outletVisible: false,
      // 选择门店数据
      xuanzhong: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
    };
  },
  created() {
    this.regionSelectList();
    this.Reportgetdisplayfiled();
    // this.lntegralquery();
    let Conversion = JSON.parse(localStorage.getItem("Conversion"));
    for (let i = 0; i < Conversion.length; i++) {
      if (Conversion[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Conversion[i].menuName == "同步") {
        this.jurisdiction.synchronization = true;
        continue;
      }
      if (Conversion[i].menuName == "废弃") {
        this.jurisdiction.abandon = true;
        continue;
      }
      if (Conversion[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (Conversion[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.pageNo >= this.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    ComButtomStore() {
      this.Sercherbox.listOfSomeStoresl = [];
      this.Sercherbox.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.Sercherbox.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.Sercherbox.listOfSomeStoresl.push(...item);
        }
      }
      this.Sercherbox.listOfSomeStoresl.forEach((item) => {
        this.Sercherbox.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      this.xuanzhong = [];
      for (let i = 0; i < this.Sercherbox.listOfSomeStoresl.length; i++) {
        this.xuanzhong.push(this.Sercherbox.listOfSomeStoresl[i].id);
      }
      this.outletVisible = false;
    },
    regionSelectList() {
      RegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);

          let arr1 = [],
            arr2 = [];
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
          console.log(this.StoreSelectionList);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取下载列表数据
    getDownladList() {
      reportFormList({ groupName: "会员兑换" }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 导出
    Export() {
      let shopID = [];
      if (this.Sercherbox.listOfSomeStoresl.length > 0) {
        this.Sercherbox.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        pageNo: this.Sercherbox.pageNo,
        pageSize: this.Sercherbox.pageSize,
        displayFiled: this.Sercherbox.displayFiled,
        redemptionNo: this.Sercherbox.redemptionNo, //兑换编号
        search: this.Sercherbox.search, //搜索内容
        collectMethod: this.Sercherbox.collectMethod, //领取方式
        commKind: this.Sercherbox.commKind, //商品类型
        state: this.Sercherbox.state, //状态
        startRedemptionTime: this.Sercherbox.startRedemptionTime, //开始时间
        endRedemptionTime: this.Sercherbox.endRedemptionTime, //结束时间
        getNo: this.Sercherbox.getNo, //pos领取单号
        commodityName: this.Sercherbox.commodityName, //商品名称
        regionIds: this.Sercherbox.regionIds.join(","), // 区域
        shopIds: shopID.join(","),
      };
      redemptionReportExportApi(data).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看!");
      });
    },
    // 选择完成
    Selectfinish() {
      this.Sercherbox.displayFiled = this.ID1;
      this.Customerwishlist = [];
      this.lntegralquery();
      this.loading = true;
      this.formThead = this.Selectdisplayitem.filter(
        (i) => this.ID1.indexOf(i.ID) >= 0
      );
      this.key = this.key + 1;
      this.SelectdisplayitemDialog = false;
    },
    // 恢复默认选项
    Restoredefault() {
      this.Selectdisplayiteme = [];
      this.Reportgetdisplayfiled();
      this.Customerwishlist = [];
      // this.Inquirycard.pageNum = 1;
      // console.log("恢复", this.Inquirycard.displayFiled);
      this.loading = true;
      this.$message.success("恢复默认选项成功!");
      this.SelectdisplayitemDialog = false;
    },
    // 显示项checkbox点击获值
    handleCheckedCitiesChange(val) {
      this.ID1 = val;
    },
    // 获取显示项
    Reportgetdisplayfiled() {
      ReportgetdisplayfiledApi({ reportId: 1005 }).then((res) => {
        if (res.success == true) {
          this.formThead = [];
          this.key = this.key + 1;
          this.Selectdisplayitem = res.data;
          // 判断是否默认选项
          this.Selectdisplayitem.forEach((item) => {
            if (item.IsDefault == true) {
              this.Selectdisplayiteme.push(item.ID);
              this.ID1 = this.Selectdisplayiteme;
              this.Sercherbox.displayFiled = this.Selectdisplayiteme;
              this.formThead.push(item);
            }
          });
          this.lntegralquery();
        }
      });
    },

    Synchronization() {
      if (this.changeRadioLabel == "") {
        this.$message({
          message: "请先选择数据,才能进行同步!",
          type: "warning",
        });
        return false;
      } else {
        if (
          this.changeRadioLabel.state == 1 ||
          this.changeRadioLabel.state == 2
        ) {
          this.$message("已领,废弃,不能上传!");
        } else {
          this.EnabledisableFormVisible = true;
        }
      }
    },
    Enabledisableqd() {
      let data = require("qs").stringify({
        id: this.changeRadioLabel.redemptionID,
        type: 5,
      });
      TApiLogsyncProcess(data).then((res) => {
        if (res.success == true) {
          this.$message.success("同步成功!");
          this.EnabledisableFormVisible = false;
          this.radio = "";
          this.changeRadioLabel = [];
        }
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //查看功能
    goToPointsShopping() {
      if (this.changeRadioLabel == "") {
        return this.$message.warning("请选择查看的数据");
      }
      this.$router.push({
        path: "/PointsShopping",
        query: {
          id: this.changeRadioLabel.redemptionID,
        },
      });
    },

    // 积分商城已兑换列表数据
    async lntegralquery() {
      let shopID = [];
      if (this.Sercherbox.listOfSomeStoresl.length > 0) {
        this.Sercherbox.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        pageNo: 1, //页
        pageSize: 20, //条
        displayFiled: this.Sercherbox.displayFiled.join(","),
        redemptionNo: this.Sercherbox.redemptionNo, //兑换编号
        search: this.Sercherbox.search, //搜索内容
        collectMethod: this.Sercherbox.collectMethod, //领取方式
        commKind: this.Sercherbox.commKind, //商品类型
        state: this.Sercherbox.state, //状态
        startRedemptionTime: this.Sercherbox.startRedemptionTime, //开始时间
        endRedemptionTime: this.Sercherbox.endRedemptionTime, //结束时间
        getNo: this.Sercherbox.getNo, //pos领取单号
        commodityName: this.Sercherbox.commodityName, //商品名称
        regionIds: this.Sercherbox.regionIds.join(","), // 区域
        shopIds: shopID.join(","),
      };
      await lntegralqueryApi(data).then((res) => {
        if (res.message == "success") {
          this.tableData = res.data.list;
          this.pages = res.data.pages;
          this.loading = false;
        } else {
          this.$message.error("获取列表数据失败");
        }
      });
    },
    //积分商城兑换列表查询
    async Integralbtn() {
      this.tableData = [];
      this.loading = true;
      let shopID = [];
      if (this.Sercherbox.listOfSomeStoresl.length > 0) {
        this.Sercherbox.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let arr = {
        pageNo: 1, //页
        pageSize: 20, //条
        displayFiled: this.Sercherbox.displayFiled.join(","),
        redemptionNo: this.Sercherbox.redemptionNo, //兑换编号
        search: this.Sercherbox.search, //搜索内容
        collectMethod: this.Sercherbox.collectMethod, //领取方式
        commKind: this.Sercherbox.commKind, //商品类型
        state: this.Sercherbox.state, //状态
        startRedemptionTime: this.Sercherbox.startRedemptionTime, //开始时间
        endRedemptionTime: this.Sercherbox.endRedemptionTime, //结束时间
        getNo: this.Sercherbox.getNo, //pos领取单号
        commodityName: this.Sercherbox.commodityName, //商品名称
        regionIds: this.Sercherbox.regionIds.join(","), // 区域
        shopIds: shopID.join(","),
      };
      await lntegralqueryApi(arr).then((res) => {
        if (res.message == "success") {
          this.$message.success("查询成功");
          this.loading = false;
          this.tableData = res.data.list;
        }
      });
    },
    //单选赋值
    handleRadioChange(val) {
      this.changeRadioValue = val.redemptionID;
      this.changeRadioLabel = val;
    },
    //下拉刷新
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.loadList();
      }, 1000);
    },
    loadList() {
      let shopID = [];
      if (this.Sercherbox.listOfSomeStoresl.length > 0) {
        this.Sercherbox.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      lntegralqueryApi({
        pageNo: this.count,
        pageSize: 20,
        displayFiled: this.Sercherbox.displayFiled.join(","),
        redemptionNo: this.Sercherbox.redemptionNo, //兑换编号
        search: this.Sercherbox.search, //搜索内容
        collectMethod: this.Sercherbox.collectMethod, //领取方式
        commKind: this.Sercherbox.commKind, //商品类型
        state: this.Sercherbox.state, //状态
        startRedemptionTime: this.Sercherbox.startRedemptionTime, //开始时间
        endRedemptionTime: this.Sercherbox.endRedemptionTime, //结束时间
        getNo: this.Sercherbox.getNo, //pos领取单号
        commodityName: this.Sercherbox.commodityName, //商品名称
        regionIds: this.Sercherbox.regionIds.join(","), // 区域
        shopIds: shopID.join(","),
      }).then((res) => {
        this.tableData = this.tableData.concat(res.data.list);
        this.pages = res.data.pages;
        this.loading = false;
      });
    },
    //废弃功能
    async wastebtn() {
      if (this.changeRadioValue == "") {
        return this.$message.warning("请选择废弃的数据");
      }
      await wastebtnqueryApi({ redemptionID: this.changeRadioValue }).then(
        (res) => {
          if (res.message == "success") {
            this.$confirm("是否真的要废弃", "提示", {
              confirmButtonText: "是",
              cancelButtonText: "否",
              type: "warning",
            })
              .then(() => {
                this.$message.success("废弃成功");
                this.lntegralquery(); //初始化数据
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
#conversion {
  height: 100%;
}
.header-text {
  height: 50px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

/deep/.Enabledisable {
  .el-dialog__header,
  .el-message-box__header {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    height: 44px;
    background: #f3f1dd;
    width: 100%;
    text-align: center;
    color: #666;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-dialog__title,
  .el-message-box__title {
    color: #6c6937;
    font-weight: 700;
    font-size: 16px !important;
  }
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coverage-release .el-dialog__body {
    padding: 20px;
  }
  .el-button:hover {
    background-color: #b6b388;
  }
  .el-dialog__body {
    padding: 30px 60px;
  }
  .el-tabs__item {
    border: 1px solid #d9d9d9;
    background-color: #fff;
    color: #6c6937;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .el-tabs__item.is-active {
    color: #6c6937;
    background-color: #f3f1dd;
  }
  .el-form-item__content {
    line-height: 0px;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
</style>
